import { render } from "./FileUploadCommon.vue?vue&type=template&id=63aaa30e&scoped=true"
import script from "./FileUploadCommon.vue?vue&type=script&lang=js"
export * from "./FileUploadCommon.vue?vue&type=script&lang=js"

import "./FileUploadCommon.vue?vue&type=style&index=0&id=63aaa30e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1189531127/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63aaa30e"]])

export default __exports__